import { useMemo, type CSSProperties, type HTMLAttributes } from 'react';
import { type IconType } from '@src/IconType.ts';
import { classNames } from '@utils/classNames.ts';

export type IconProps = {
  readonly type: IconType;
  readonly className?: string;
  readonly maskSize?: string;
  size?: 'x-small' | 'small' | 'medium';
} & HTMLAttributes<HTMLSpanElement>;

export function Icon({ type, className, maskSize, size, ...rest }: IconProps) {
  const fullClassName = useMemo(
    () => `icon icon-${type} mask-centered block`,
    [type],
  );

  const style =
    maskSize == null
      ? undefined
      : ({ '--maskSize': maskSize } as CSSProperties);

  const sizeClass = useMemo(() => {
    if (!size) return '';
    switch (size) {
      case 'x-small':
        return 'size-3';
      case 'small':
        return 'size-4';
      case 'medium':
        return 'size-6';
    }
  }, [size]);

  return (
    <span
      className={classNames(fullClassName, sizeClass, className)}
      style={style}
      {...rest}
    ></span>
  );
}
